import { t } from "i18next";
import { Tag } from "primereact/tag";
import { formatDateUTC } from "./user";
export const getStatusBox = (status) => {
	switch (status) {
		case 15:
			return {
				variant: 'success',
				text: "accepted"
			};
			break;

		case 29:
			return {
				variant: 'info',
				text: "На складе"
			};
			break;
		case 2:
			return {
				variant: '',
				text: "expectConfirm"
			};
			break;
		case 3:
		case 16:
			return {
				variant: 'info',
				text: "in_way"
			};;
			break;
		case 18:
			return {
				variant: 'success',
				text: "receipts"
			};;
			break;
		case 4:
			return {
				variant: 'success',
				text: "cameWarehouse"
			};

		case 24:
			return {
				variant: 'success',
				text: "RFdelivery"
			};
		default:
			return {
				variant: 'warning',
				text: "atSclad"
			};
	}
};

export const boxColumn = [
	{
		attr: "guid",
		label: "GUID",
		type: 1,
		hidden: true,
		editor: false
	},
	{
		attr: "codeid",
		label: "ID",
		type: 2,
		hidden: true,
		editor: false
	},
	{
		attr: "tracking_code",
		label: "tracking_code",
		type: 1,
		hidden: false,
		editor: false
	},
	{
		attr: "warehouse_guid",
		label: "warehouse",
		type: 3,
		opt: 7,
		optionlabelKey: "warehouse",
		optionValue: "guid",
		hidden: true,
		editor: false
	},
	{
		attr: "warehouse",
		label: "warehouse",
		// type: 3,
		// opt: 7,
		// optionlabelKey: "warehouse",
		// optionValue: "guid",
		hidden: false,
		editor: false
	},

	{
		attr: "partial",
		label: "partial",
		type: 3,
		opt: 8,
		optionlabelKey: "partial_name",
		optionValue: "guid",
		hidden: true,
		editor: false
	},
	{
		attr: "partial_code",
		label: "partial_code",
		type: 1,
		opt: 8,
		optionlabelKey: "partial_code",
		optionValue: "guid",
		hidden: false,
		editor: false
	},
	{
		attr: "date_created",
		label: "date_create_box",
		type: 1,
		opt: 8,
		optionlabelKey: "partial_name",
		optionValue: "guid",
		hidden: false,
		editor: false,
		body: (rowData) => {
			return formatDateUTC(rowData.date_created).toLocaleString()
		}
	}, {
		attr: "orderCount",
		label: "orderCount",
		type: 2,
		hidden: false,
		editor: false,
	},
	{
		attr: "status",
		label: "status",
		hidden: false,
		editor: false,
		body: (rowData, trans) => {
			return <Tag value={trans(getStatusBox(rowData.status).text)} severity={getStatusBox(rowData.status).variant} />;
		}
	},
	{
		attr: "width",
		label: "width",
		type: 2,
		hidden: false,
		editor: true
	},
	{
		attr: "height",
		label: "height",
		type: 2,
		hidden: false,
		editor: true
	},
	{
		attr: "length",
		label: "length",
		type: 2,
		hidden: false,
		editor: true
	},
	{
		attr: "v_weight",
		label: "v_weight",
		type: 2,
		hidden: false,
		editor: true,
		body: (item) => {
			return Number(parseFloat(item.v_weight) || 0).toFixed(2) ?? ''
		}
	},
	{
		attr: "gross_weight",
		label: "gross_weight",
		type: 2,
		hidden: false,
		editor: true
	},
	{
		attr: "brand",
		label: "brand",
		type: 1,
		opt: 9,
		optionlabelKey: "name",
		optionValue: "code",
		hidden: true,
		editor: false
	},
	{
		attr: "export",
		label: "export",
		type: 2,
		hidden: true,
		editor: false
	},
	{
		attr: "company",
		label: "company",
		type: 2,
		opt: 10,
		optionlabelKey: "name",
		optionValue: "code",
		hidden: true,
		editor: false
	},
];

export const createBoxColumn = [
	{
		attr: "guid",
		label: "GUID",
		type: 1,
		hidden: true,
		editor: false
	},
	{
		attr: "codeid",
		label: "ID",
		type: 2,
		hidden: false,
		editor: true
	},
	{
		attr: "box",
		label: "box",
		type: 1,
		hidden: false,
		editor: true
	},
	{
		attr: "order",
		label: "order",
		type: 3,
		opt: 7,
		optionlabelKey: "warehouse",
		optionValue: "guid",
		hidden: false,
		editor: true
	},
];

export const createOrderToBox = [
	{
		attr: "guid",
		label: "GUID",
		type: 1,
		hidden: true,
		editor: false
	},
	{
		attr: "codeid",
		label: "ID",
		type: 2,
		hidden: false,
		editor: true
	},
	{
		attr: "tracking_code",
		label: "tracking_code",
		type: 1,
		hidden: true,
		editor: true
	},
	{
		attr: "partial_code",
		label: "partial_code",
		type: 2,
		hidden: true,
		editor: true
	},
	{
		attr: "date_create",
		label: "date_create",
		type: 1,
		hidden: false,
		editor: false,
		body: (rowData) => {

			if (!rowData.date_created) return "";

			return formatDateUTC(rowData.date_created).toLocaleString()
		}
	},
	{
		attr: "date_accept",
		label: "date_accept",
		type: 1,
		hidden: false,
		editor: false,
		body: (rowData) => {

			if (!rowData.date_accept) return "";

			return formatDateUTC(rowData.date_accept).toLocaleString()
		}
	},
	{
		attr: "tracking_number",
		label: "tracking_number",
		type: 3,
		opt: 7,
		optionlabelKey: "warehouse",
		optionValue: "guid",
		hidden: false,
		editor: true
	},
	{
		attr: "gross_weight",
		label: "brutto",
		type: 2,
		hidden: false,
		editor: true
	},
	{
		attr: "v_weight",
		label: "v_weight",
		type: 2,
		hidden: false,
		editor: true,
		body: (item) => {
			return Number(parseFloat(item.v_weight) || 0).toFixed(2) ?? ''
		}
	},
	{
		attr: "width",
		label: "width",
		type: 2,
		hidden: false,
		editor: true
	},
	{
		attr: "height",
		label: "height",
		type: 2,
		hidden: false,
		editor: true
	},
	{
		attr: "length",
		label: "length",
		type: 2,
		hidden: false,
		editor: true
	}
]
